import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <div className="footer padded-sec">
        <div className='abs-list ftrShape1'> 
        </div>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-xl-3 col-lg-6 col-sm-6 col-xs-12'>
               <Link to="/"><div className='ftr-logo'> 
                  <img src="https://webapi.entab.info/api/image/SHCSKWB/public/Images/footerlogo.png" alt="SHCSKWB" />  
              </div>
              </Link>
            </div>
            
            <div className='col-xl-4 col-lg-6 col-sm-6 col-xs-12'>
            <h3>Quick Links</h3>
              <div className='quick-link'>
              
                <ul> 
                  <li><Link to="/AboutUs"><i class="bi bi-caret-right-fill"></i> ABOUT</Link></li>  
                  <li><Link to="/ErpSoftware"><i class="bi bi-caret-right-fill"></i>  ERP SOFTWARE </Link></li>
                  <li><Link to="/Pphelp"><i class="bi bi-caret-right-fill"></i>   PORTAL (HELP?)</Link></li> 
                  <li><Link to="/Tc"><i class="bi bi-caret-right-fill"></i>  TRANSFER CERTIFICATE </Link></li> 
                   <li><Link to="/" target="_blank"><i class="bi bi-caret-right-fill"></i> FEE PAYMENT</Link></li>
                   <li><Link to="/" target="_blank"><i class="bi bi-caret-right-fill"></i> ERP LOGIN</Link></li>
                   
                </ul>
                <div class="app-cont">
                    <p>Applying leave of absence on behalf of your ward is easy with the app. You will get instant notification on your app of leave's approval or rejection.</p>
                    <div> 
                      <a href="https://apps.apple.com/in/app/campuscare/id1034721587" target="_blank">
                        <img src="https://webapi.entab.info/api/image/SHCSKWB/public/Images/apple.png" class="img-fluid"/>
                      </a>
                      <a href="https://play.google.com/store/apps/details?id=com.campuscare.entab.ui" target="_blank">
                        <img src="https://webapi.entab.info/api/image/SHCSKWB/public/Images/playstore.png" class="img-fluid"/>
                      </a>
                      </div>
                      <p class="link">shhsk.campussoft.in</p>
                    </div>
              </div>
            </div>
           
            <div className='col-xl-3 col-lg-6 col-sm-6 col-xs-12 address'>
              <h3>Address</h3>
              <p><i class="bi bi-house-door-fill"></i> <span><Link to="https://maps.app.goo.gl/y7Y4Bb7wq7Zp5SDu9" target="_blank">Sacred Heart Educational Trust School<br /> Kharagpur, West Bengal 721301</Link></span></p>
              <p><i class="bi bi-telephone-fill"></i> <span> <a href="tel:03222256266">03222 256266</a></span></p>
              <p><i class="bi bi-envelope-fill"></i> <span> <a href="mailto:shhs.kgp@gmail.com">shhs.kgp@gmail.com</a> </span></p>
            </div>
            <div className='col-xl-2 col-lg-6 col-sm-6 col-xs-12'>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.570876005311!2d87.32422232362894!3d22.332063397509177!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a1d443ee5dd655b%3A0xe547ff8417ec3912!2sSacred%20Heart%20High%20School!5e0!3m2!1sen!2sin!4v1752637579154!5m2!1sen!2sin" width="100%" height="200px" frameborder="0" allowfullscreen=""></iframe>
              </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <ul className='socialMedia'>
                <li><Link to="#" target="_blank"><img src="https://webapi.entab.info/api/image/SHCSKWB/public/Images/facebook.png" alt="SHCSKWB" /></Link></li>
                <li><Link to="#" target="_blank"><img src="https://webapi.entab.info/api/image/SHCSKWB/public/Images/youtube.png" alt="SHCSKWB" /></Link></li>
                <li><Link to="#" target="_blank"><img src="https://webapi.entab.info/api/image/SHCSKWB/public/Images/insta.png" alt="SHCSKWB" /></Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className='copyright'>
      ©️ 2025 Sacred Heart Educational Trust School | Designed & developed by <Link to="https://www.entab.in/" target="_blank">Entab Infotech: CampusCare®️ </Link>
      </div>
    </>
  );
}

export default Footer;
